import Store from 'store/store';

Store.on('SHOW_LOGIN_SCREEN', ({ show, desiredScreen }) => {
	if (show) {
		Store.emit('SHOW_PRIME_BLOCK', false);
	}
	Store.get().showtimes.set({
		showLoginScreen: show,
	});
	if (desiredScreen) {
		Store.get().showtimes.set({
			desiredScreen
		});
	}
});

Store.on('SHOW_PRIME_BLOCK', (bool) => {
	Store.get().showtimes.set({
		showPrimeBlock: bool
	});
});

Store.on('RESET_DESIRED_SCREEN', () => {
	Store.get().showtimes.set({
		desiredScreen: undefined
	});
});

Store.on('SHOW_TICKET_AREA', (bool) => {
	Store.get().showtimes.set({
		showTicketArea: bool
	});
});

Store.on('SHOW_INFO_SCREEN', (data) => {
	Store.get().showtimes.set({
		showInfoScreen: true,
		infoScreenData: data
	});
});

Store.on('HIDE_INFO_SCREEN', () => {
	Store.get().showtimes.set({
		showInfoScreen: false
	});
});

Store.on('SHOW_FULL_LOADER', (bool) => {
	Store.get().showtimes.set({
		showFullScreenLoader: bool
	});
});

Store.on('RETRIEVED_PROFILE', (profile) => {
	Store.get().showtimes.set({
		customer: {
			name: profile?.Name,
			email: profile?.PrimaryEmail,
			id: profile?.CustomerId
		}
	});
});

Store.on('RETRIEVED_USER_TICKETS', (tickets) => {
	const store = Store.get();
	const customerData = store.showtimes.customer || {};
	Store.get().showtimes.set({
		customer: {
			...customerData,
			tickets
		}
	});
});

Store.on('EARLY_ACCESS_WINDOW', () => {
	Store.get().showtimes.set({
		earlyAccessWindow: true
	});
});

Store.on('EARLY_ACCESS_CODE_ACCEPTED', (earlyAccessCode) => {
	Store.get().showtimes.set({
		earlyAccessCode
	});
});

Store.on('CHANGE_INFO_SCREEN_MESSAGE', (message) => {
	const store = Store.get() || {};
	const infoScreenData = store.showtimes?.infoScreenData || {};
	Store.get().showtimes.set({
		infoScreenData: {
			...infoScreenData,
			message
		}
	});
});
